import { jsx as _jsx } from "react/jsx-runtime";
import { useLiveAnchor } from "../hooks/useLiveAnchor.js";
import { Marker, markerModeFor } from "./Marker.js";
export const LiveMarker = ({ annotation, number, onRemove, onEdit, }) => {
    const live = useLiveAnchor(annotation.elementPath, annotation.boundingBox);
    if (!live)
        return null;
    const cx = live.x + live.width / 2;
    const cy = live.y + live.height / 2;
    const mode = markerModeFor(annotation);
    const titleParts = [annotation.comment];
    if (live.missing) {
        titleParts.push("⚠ The original element is no longer on the page.");
    }
    else if (live.drifted) {
        titleParts.push("✱ The element has moved since this annotation was captured.");
    }
    return (_jsx(Marker, { number: number, x: cx, y: cy, mode: mode, title: titleParts.join("  ·  "), drifted: live.drifted, missing: live.missing, ...(onRemove ? { onRemove } : {}), ...(onEdit ? { onEdit } : {}) }));
};
//# sourceMappingURL=LiveMarker.js.map